<toaster-container [toasterconfig]="errorConfig"></toaster-container>
<xvi-notification-box></xvi-notification-box>
